/**
 * @generated SignedSource<<31f6aa2db14f00a41aebcc72a3fa1e14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Programs_enrollments$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ClientPastProgramCard_enrollment" | "ClientProgramProgressCard_enrollment" | "ClientUpcomingProgramCard_enrollment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "Programs_enrollments";
};
export type Programs_enrollments$key = {
  readonly " $data"?: Programs_enrollments$data;
  readonly " $fragmentSpreads": FragmentRefs<"Programs_enrollments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Programs_enrollments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EnrollmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Enrollment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClientProgramProgressCard_enrollment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClientUpcomingProgramCard_enrollment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClientPastProgramCard_enrollment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EnrollmentConnection",
  "abstractKey": null
};

(node as any).hash = "6164bb60476c1f906828cb552198f85d";

export default node;
